import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import type { MyTripsQuery } from '../gql/graphql';

const myTripsQuery = graphql(/* GraphQL */ `
  query myTrips {
    myTrips {
      tripId
      routeId
      embarkationDate
      disembarkationDate
      boatId
      organizerId
      routeName
      boatName
      diveCount
    }
  }
`);

const useGetPartnerTrips = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, isLoading, error } = useQuery<MyTripsQuery>({
    queryKey: ['partnerTrips'],
    queryFn: async () => {
      return graphqlRequest<MyTripsQuery>(
        myTripsQuery,
        undefined,
        getAccessTokenSilently,
      );
    },
    enabled: isAuthenticated,
    staleTime: 300000, // 5 minutes
    retry: shouldRetryQuery,
  });

  return {
    trips: data?.myTrips || [],
    isLoading,
    isError: !!error,
    error,
  };
};

export default useGetPartnerTrips;
